import { HTMLProps } from "react";
import { twMerge } from "tailwind-merge";

export function ModelNoImage({
  className,
}: {
  className?: HTMLProps<HTMLDivElement>["className"];
}) {
  return (
    <div
      className={twMerge(
        "flex h-full w-full items-center justify-center bg-gray-200 text-6xl",
        className
      )}
    >
      🎤
    </div>
  );
}
